import * as React from 'react';
import * as moment from 'moment';
import styled from 'styled-components';
import { localeMapping, IState } from '../../lib/localeMapping';
import IRewardPurchase from '../../lib/types/RewardPurchase';
import IReward from 'src/lib/types/Reward';
import IRewardCategory from '../../lib/types/RewardCategory';
import SmilesIcon from '../icons/SmilesIcon';
import MailTo from '../MailTo';

const ListItem = styled.li`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 1em;
  background: #fefefe;
  border-bottom: 1px solid #a9a9a9;
  @media (max-width: 500px) {
    padding: 0.5em;
    flex-wrap: wrap;
  }
`;

const ItemImg = styled.img`
  width: 20%;
  height: 7rem;
  object-fit: contain;
  @media (max-width: 500px) {
    width: 30%;
  }
`;

const ItemPurchase = styled.span`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 0.5em;
  @media (max-width: 500px) {
    flex-direction: column;
  }
`;

const ItemName = styled.span`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-style: italic;
  color: #586e75;
  padding: 1em;
  @media (max-width: 700px) {
    padding: 0;
  }
`;

const ItemDetails = styled.span`
  display: flex;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;

`;

const ItemPurchaseEntry = styled.span`
  padding: 0.3em 0;
  font-size: 16px;
  @media (max-width: 700px) {
    font-size: 14px;
  }
  @media (max-width: 400px) {
    font-size: 12px;
  }
`;

// tslint:disable:max-line-length
interface ISupportMail {
  to: string;
  subject: (purchase: IRewardPurchase) => string;
  body: (purchase: IRewardPurchase, reward: IReward, category: IRewardCategory) => string;
}

const cadoozMail: ISupportMail = {
  to: 'service@cadooz.de',
  subject: (purchase: IRewardPurchase) => `Mein Gutscheincode mit der Referenznummer ${getPurchaseId(purchase)}`,
  body: (purchase: IRewardPurchase, reward: IReward, category: IRewardCategory) =>
      `Sehr geehrtes Team von Cadooz,

ich wende mich an Sie, da ich meinen Gutscheincode mit der Referenznummer ${getPurchaseId(purchase)} noch nicht erhalten habe.
Die Bestellung wurde am ${moment(purchase.stateChangedAt).add(1, 'M').format('DD.MM.YYYY')} ausgelöst.

Bitte senden Sie mir den Gutscheincode sobald wie möglich zu.



Ich freue mich über Ihre Rückmeldung.

Vielen Dank im Voraus!`,
};

const supportEmail: ISupportMail = {
  to: 'info@tvsmiles.de',
  subject: (purchase: IRewardPurchase) => `Bestellung ${getPurchaseId(purchase)}`,
  body: (purchase: IRewardPurchase, reward: IReward, category: IRewardCategory) => `Hallo liebes TVSMILSE Team,

ich habe meine Bestellung ${category.name} - ${reward.name} mit der Referenznummer ${getPurchaseId(purchase)} leider noch nicht erhalten.

Ich bitte um Hilfe.


Ich freue mich über Ihre Rückmeldung.

Vielen Dank im Voraus!\`,

  `,
};

function getPurchaseId(purchase: IRewardPurchase) {
  return purchase.id.replace('legacy-', '');
}

interface IProps {
  rewardPurchase: IRewardPurchase;
  rewards: IReward[];
  rewardCategories: IRewardCategory[];
}

export default function RewardPurchaseListItem(props:IProps) {
  const rewardPurchase = props.rewardPurchase;
  const state: IState = localeMapping(rewardPurchase.state);
  const reward: IReward | undefined = props.rewards.find(r => r.id === rewardPurchase.rewardId);
  if (!reward) {
    return null;
  }
  const rewardCategory = props.rewardCategories.find(rc => rc.id === reward.rewardCategoryId);
  if (!rewardCategory) {
    return null;
  }
  const supportMail = rewardCategory.processId === 'cadooz' ? cadoozMail : supportEmail;
  return (
        <ListItem>
            <ItemImg src={reward.imageUrl} alt="Reward Image"/>
            <ItemPurchase>
                <ItemName>{rewardCategory.name}, {reward.name}</ItemName>
                <ItemDetails>
                    <ItemPurchaseEntry>
                        <b style={{ color: 'black' }}>Status: </b>
                        <span style={{ color: state.color }}>{state.text}</span>
                    </ItemPurchaseEntry>
                    <ItemPurchaseEntry>
                        <b>Smiles:</b> {reward.amount} <SmilesIcon/>
                    </ItemPurchaseEntry>
                    <ItemPurchaseEntry>
                        <b>Bestelldatum:</b> {moment(rewardPurchase.date).format('DD.MM.YYYY')}
                    </ItemPurchaseEntry>
                    {
                        ['pending', 'approved', 'scheduledForDelivery'].indexOf(rewardPurchase.state) > -1 &&
                        <ItemPurchaseEntry>
                            <b>Geplanter Liefertermin:</b> {moment(rewardPurchase.date).add(1, 'M').format('DD.MM.YYYY')}
                        </ItemPurchaseEntry>
                    }
                    {
                        rewardPurchase.state === 'deliverySent' && rewardPurchase.stateChangedAt &&
                        <ItemPurchaseEntry>
                            <b>Versandt am:</b><span> {moment(rewardPurchase.stateChangedAt || rewardPurchase.date).format('DD.MM.YYYY')}</span>
                            {
                                ['cadooz', 'postalMail', 'paypal'].indexOf(rewardCategory.processId) > -1
                                && moment() > moment(rewardPurchase.stateChangedAt).add(5, 'days')
                                && moment() < moment(rewardPurchase.stateChangedAt).add(6, 'weeks')
                                &&
                                <span>
                                    {' ('}
                                    <MailTo to={supportMail.to}
                                            subject={supportMail.subject(rewardPurchase)}
                                            body={ supportMail.body(rewardPurchase, reward, rewardCategory) }>
                                             Nicht erhalten?
                                         </MailTo>
                                    {')'}
                                </span>
                            }
                        </ItemPurchaseEntry>
                    }
                </ItemDetails>
            </ItemPurchase>
        </ListItem>
  );
}
// tslint:enable:max-line-length



// WEBPACK FOOTER //
// ./src/components/RewardPurchaseList/RewardPurchaseListItem.tsx